// B2CBlogDetailsPage.tsx
import { Box, Heading, VStack, Text, AspectRatio, useColorModeValue } from "@chakra-ui/react";
import PublicLayout from "./Layouts/PublicLayout";
import { useParams } from "react-router-dom";
import { useState, useCallback, useEffect } from "react";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import B2CMarkdownLongText from '../Components/B2CMarkDownLongText';

interface BlogDetail {
  blog_id: number;
  title: string;
  headline?: string;
  author_name?: string;
  published_at?: string;
  long_description?: string;
  blog_image_key?: string;
  card_image_key?: string;
  meta_title ?:string;
  meta_description ?:string;
}

const B2CBlogDetailsPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const [blog, setBlog] = useState<BlogDetail>();
  const mutedText = useColorModeValue("gray.500", "gray.400");

  const fetchBlog = useCallback(async () => {
    if (!slug) return;
    try {
      const apiUrl = process.env.REACT_APP_API_URL || "https://default-url.com";
      const response = await axios.get(`${apiUrl}/b2c/public/blog/${slug}`);
      setBlog(response.data);
    } catch (error) {
      console.error("Failed to load blog", error);
    }
  }, [slug]);

  useEffect(() => { fetchBlog(); }, [fetchBlog]);

  useEffect(() => {
  if (!blog) return;

  const title =
    blog.meta_title ??
    blog.headline ??
    "Default Title";

  document.title = title;

  const meta = document.querySelector("meta[name='description']");
  if (meta) {
    meta.setAttribute(
      "content",
      blog.meta_description ?? ""
    );
  }
}, [blog]);

useEffect(() => {
  if (!slug) return;

  let link = document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = `https://eduvic.com.au/practice/blog/${slug}`;

  // Remove on leaving so other routes don't inherit this canonical
  return () => {
    link?.remove();
  };
}, [slug]);

  if (!blog) return null;

  return (
    <PublicLayout>
      <Box maxW="1200px" mx="auto" py={12} px={6}>
        <VStack align="start" spacing={4}>
          <Heading size="2xl">{blog.headline || blog.title}</Heading>
          <Text fontSize="sm" color={mutedText}>
            {blog.author_name} {blog.published_at && `· ${new Date(blog.published_at).toLocaleDateString()}`}
          </Text>

          {(blog.blog_image_key || blog.card_image_key) && (
            <AspectRatio w="100%" ratio={{ base: 16 / 9, md: 21 / 9 }} borderRadius="lg" overflow="hidden">
              <Box
                bgImage={{
                  base: `url(${blog.card_image_key || blog.blog_image_key})`,
                  md: `url(${blog.blog_image_key || blog.card_image_key})`,
                }}
                bgSize="cover"
                bgPosition="center"
              />
            </AspectRatio>
          )}

          {blog.long_description && (
            <Box fontSize="md" w="100%">
              <B2CMarkdownLongText content={blog.long_description} />
            </Box>
          )}
        </VStack>
      </Box>
    </PublicLayout>
  );
};

export default B2CBlogDetailsPage;